<template>
  <div class="firmwareCamsTable">
    <v-sheet class="firmwareCamsTable_content">
      <resizable-page ref="page" :footer-height="40" calc-header>
        <template slot="header">
          <setting-header />
          <v-spacer class="firmwareCamsTable_gap-header" />
          <section v-if="showTabs" class="firmwareCamsTable_tabs-wrapper">
            <v-tabs
              v-model="tabs"
              height="26px"
              centered
              dense
              :hide-slider="true"
              class="firmwareCamsTable_tabs"
              active-class="firmwareCamsTable_tabs-active"
            >
              <v-tab
                v-for="(item, index) in tabItems"
                :key="index"
                @click="handleViewList(item.value)"
              >
                {{ item.label }}
              </v-tab>
            </v-tabs>
            <span
              v-if="updateVersionExists"
              class="firmwareCamsTable_circle-icon"
            ></span>
          </section>
        </template>
        <template #table="tableProps">
          <span
            v-if="tableItems.length === 0 && displayFirmware"
            class="firmwareCamsTable_update-message"
          >
            全て最新です。</span
          >
          <template v-else>
            <template v-if="displayFirmware">
              <span class="firmwareCamsTable_update-message"
                >最新のファームウェアが提供されているカメラの一覧です。</span
              >
              <br />
              <span class="firmwareCamsTable_update-warn"
                >ファームウェアの更新中は録画とライブが停止されますのでご注意ください。</span
              >
              <br />

              <v-btn
                :disabled="!anySelected"
                class="firmwareCamsTable_update-btn"
                @click="handleUpdateSelectedFirmwares"
                >ファームウェアを更新する</v-btn
              >
            </template>

            <v-data-table
              :height="tableProps.bodyHeight"
              :headers="computedHeaders"
              :items="tableItems"
              hide-default-footer
              disable-pagination
              item-key="index"
              sort-by="dateTime"
              class="firmwareCamsTable_tbl"
              :fixed-header="true"
            >
              <template #[`header.selection`]="{}">
                <app-check :value="allSelected" @input="handleSelectAll" />
              </template>
              <!-- Table body template  -->
              <template #item="{ item }">
                <tr @click="handleClickRow(item)">
                  <td v-if="displayFirmware" class="text-center">
                    <img
                      v-if="item.updatingState === 1"
                      class="firmwareCamsTable_rotate"
                      src="@/assets/img/ico_firmware_updating.svg"
                      alt=""
                    />
                    <app-check
                      v-else
                      :value="isSelected(item)"
                      @input="toggleSelect(item)"
                    />
                  </td>
                  <td class="text-start">
                    <tooltip :classes="'firmwareCamsTable_tbl-tooltip'">
                      <template #activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          class="firmwareCamsTable_tbl-name text-truncate"
                          v-on="on"
                        >
                          {{ item.camName }}
                        </div>
                      </template>
                      <h2>{{ item.camName }}</h2>
                    </tooltip>
                  </td>
                  <!-- <td class="text-start">
                    <span class="firmwareCamsTable_tbl-dateTime">
                      {{ item.camPropName }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="firmwareCamsTable_tbl-modelName">
                      {{ item.modelName }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span
                      v-if="!!item.serialNumber"
                      class="firmwareCamsTable_tbl-serialNumber"
                    >
                      {{ item.serialNumber }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span class="firmwareCamsTable_tbl-firmwareVerion">
                      {{ item.firmwareVersion }}
                    </span>
                    <span
                      v-if="item.updatingState === 1"
                      class="firmwareCamsTable_tbl-firmwareUpdateMessage"
                    >
                      ファームウェア更新中…
                    </span>
                    <span
                      v-else-if="item.updatingState === 0"
                      class="firmwareCamsTable_tbl-firmwareUpdate"
                      @click="handleUpdateFirmware(item)"
                      >{{ item.firmwareUpdate }}</span
                    >
                  </td>
                  <td class="text-center">
                    <span class="firmwareCamsTable_tbl-packageVersion">
                      {{ item.packageVersion }}
                    </span>
                  </td> -->
                </tr>
              </template>
              <!-- ----------------- -->
              <!-- Table no data -->
              <template #no-data>
                <h3>No Data</h3>
              </template>
              <!-- ----------------- -->
            </v-data-table>
          </template>
        </template>
      </resizable-page>
    </v-sheet>
    <!-- Dialogs -->
    <!-- Update firmware dialog -->
    <clip-dialog-a
      :open="dialogUpdateFirmwareOpen"
      title="ファームウェア更新"
      @onClose="closeDialogUpdateFirmware"
    >
      <div class="firmwareCamsTable_dialog-content">
        <span class="firmwareCamsTable_dialog-content--warn">
          ファームウェアの更新中は録画とライブが停止されます
        </span>
        <span>更新してもよろしいですか？</span>
      </div>
      <template #actions>
        <v-btn
          class="firmwareCamsTable_dialog-btn firmwareCamsTable_dialog-cancel"
          color="text"
          @click="closeDialogUpdateFirmware"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="firmwareCamsTable_dialog-btn firmwareCamsTable_dialog-update"
          color="text"
          :loading="updatingFirmware && !displayFirmware"
          @click="handleUpdateFirmwareOk"
        >
          更新する
        </v-btn>
      </template>
    </clip-dialog-a>
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { CameraFirmwareType, MimeTypes } from '@/globals/enums';
import SettingHeader from '../SettingHeader.vue';
import ClipDialogA from '@/components/dialogs/ClipDialogA.vue';
import { getFirmwareLatestVersion } from '@/utils/helpers';
import { dialogService } from '@/services/dialog.service';

export default {
  name: 'FirmwareCamsTable',
  components: {
    SettingHeader,
    ClipDialogA,
  },
  data() {
    return {
      mimeTypes: MimeTypes,
      dialogUpdateFirmwareOpen: false,
      updatingFirmware: false,
      cameraStatus: {},
      showVideo: true,
      tabs: null,
      tabItems: [
        {
          label: '全てのカメラ',
          value: 'all',
        },
        {
          label: 'ファームウェア更新',
          value: 'firmware',
        },
      ],
      headers: [
        {
          value: 'selection',
          align: 'center',
          sortable: false,
          width: 40,
        },
        {
          value: 'thumbnailUrl',
          align: 'start',
          sortable: false,
        },
        {
          text: 'カメラ名称',
          align: 'start',
          sortable: false,
          value: 'camName',
          // width: '130',
          class: 'firmwareCamsTable_tbl--header-name',
        },
        // {
        //   text: 'カメラ物件名称',
        //   value: 'camPropName',
        //   align: 'start',
        //   sortable: false,
        // },
        // {
        //   text: '機種名',
        //   value: 'modelName',
        //   sortable: false,
        //   align: ' d-none', // 'center'
        // },
        // {
        //   text: 'シリアル番号',
        //   value: 'serialNumber',
        //   sortable: false,
        //   align: ' d-none', // 'center',
        // },
        // {
        //   text: 'ファームウエアバージョン',
        //   value: 'firmwareVersion',
        //   sortable: false,
        //   align: 'center',
        // },
        // {
        //   text: 'パッケージバージョン',
        //   value: 'createDate',
        //   align: 'center',
        //   sortable: false,
        // },
      ],
      selectedItems: [],
      clipToolsOpen: false,
      displayImage: false,
      displayFirmware: false,
    };
  },
  computed: {
    ...mapGetters('common', {
      cameraList: 'allCamList',
      updateVersionExists: 'updateVersionExists',
    }),
    ...mapState({
      videoClips: (state) =>
        state.video.videoClips.map((item, index) => ({ ...item, index })),
      searchKeys: (state) => state.common.searchKeys,
      cameraById: (state) => state.common.cameraById,
      iamKey: (state) => state.common.iam.accessKeyId,
      iamSecret: (state) => state.common.iam.secretAccessKey,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    showTabs() {
      return this.isCurrentAvatarOwner;
    },
    tableItems() {
      const cameraList = this.displayFirmware
        ? this.cameraList.filter((obj) => {
            const cam = this.cameraById[obj.id];
            return (
              cam.UpdateVersion &&
              cam.UpdateVersion.some(
                (uv) =>
                  [0, 1, 3].includes(uv.updatingState) &&
                  [
                    CameraFirmwareType.firmware,
                    CameraFirmwareType.arobaViewRa,
                  ].includes(uv.name)
              )
            );
          })
        : this.cameraList;
      return cameraList.map((obj) => {
        const item = this.cameraById[obj.id];
        let firmwareUpdate = '';
        let packageVersion = '';
        let updatingState = 3;
        let latestUpdateVersion = null;
        let latestOperatingVersion = null;
        if (item.UpdateVersion && item.UpdateVersion.length > 0) {
          latestUpdateVersion = getFirmwareLatestVersion(item.UpdateVersion);
          firmwareUpdate = item.UpdateVersion[0].name;
          updatingState = item.UpdateVersion[0].updatingState;
        }

        let firmwareVersion = '';
        if (item.OperatingVersion && item.OperatingVersion.length > 0) {
          latestOperatingVersion = getFirmwareLatestVersion(
            item.OperatingVersion
          );
          firmwareVersion = item.OperatingVersion[0].name;
          packageVersion = item.OperatingVersion[0].version;
        }
        return {
          id: item.id,
          thumbnailUrl: '/img/events/1.png',
          camName: item.name,
          camPropName: item.groupName,
          modelName: 'VIVOTEK FD9166-HN',
          serialNumber: 'XX-XX-XX-XX-XX-XX',
          firmwareVersion,
          firmwareUpdate,
          packageVersion,
          updatingState,
          latestOperatingVersion,
          latestUpdateVersion,
          kvsVideoStreamName: item.kvsVideoStreamName,
          awsRegionName: item.awsRegionName,
        };
      });
    },
    computedHeaders() {
      return this.headers.map((item) => {
        if (item.value === 'thumbnailUrl') {
          return {
            ...item,
            align: this.displayImage ? 'start' : ' d-none',
          };
        }
        if (item.value === 'selection') {
          return {
            ...item,
            align: this.displayFirmware ? 'start' : ' d-none',
          };
        }
        if (item.value === 'camName') {
          return {
            ...item,
            text: this.displayFirmware ? '一括選択' : 'カメラ名称',
          };
        }
        return item;
      });
    },
    anySelected() {
      return this.selectedItems.length > 0;
    },
    allSelected() {
      return (
        this.selectedItems.length ===
          this.tableItems.filter((item) => item.updatingState !== 1).length &&
        this.selectedItems.length > 0
      );
    },
  },
  watch: {
    dialogUpdateFirmwareOpen(val) {
      val || this.closeDialogUpdateFirmware();
    },
  },

  created() {
    // this.initialize();
  },
  mounted() {},
  methods: {
    ...mapActions('settings', ['updateFirmware']),
    handleClickRow(item) {
      this.$router.push({
        name: 'settings-firmware-details',
        params: { id: item.id },
      });
    },
    handleCamStatus({ status, id }) {
      this.$set(this.cameraStatus, id, status);
    },
    handleOpenImageDisplay() {
      this.$refs.page.onResize();
    },
    handleUpdateSelectedFirmwares() {
      this.dialogUpdateFirmwareOpen = true;
    },
    handleUpdateFirmware(item) {
      this.selectedItems = [item];
      this.dialogUpdateFirmwareOpen = true;
    },
    showErrorDialog() {
      dialogService.showErrorDialog(
        {
          title: 'ファームウェア更新エラー',
          content: `ファームウェアの更新に失敗しました。<br>
ファームウェアの更新に失敗しました。`,
          cancel: false,
        },
        {
          classes: ['height-245'],
          width: 423,
        }
      );
    },
    async handleUpdateFirmwareOk() {
      try {
        this.updatingFirmware = true;
        if (this.displayFirmware) {
          this.closeDialogUpdateFirmware();
        }
        const updatingData = {
          [CameraFirmwareType.firmware]: [],
          [CameraFirmwareType.arobaViewRa]: [],
        };

        this.selectedItems.forEach((item) => {
          if (item.latestUpdateVersion[CameraFirmwareType.firmware]) {
            updatingData[CameraFirmwareType.firmware].push(item);
          }
          if (item.latestUpdateVersion[CameraFirmwareType.arobaViewRa]) {
            updatingData[CameraFirmwareType.arobaViewRa].push(item);
          }
        });
        this.selectedItems = [];
        const result = await this.updateFirmware(updatingData);
        if (result.every((item) => item.code === 1)) {
          this.showErrorDialog();
        }
        this.closeDialogUpdateFirmware();
      } catch (error) {
        console.error(error);
      } finally {
        this.updatingFirmware = false;
      }
    },
    closeDialogUpdateFirmware() {
      this.dialogUpdateFirmwareOpen = false;
    },
    handleSelectAll(value) {
      this.selectedItems = value
        ? this.tableItems.filter((item) => item.updatingState !== 1)
        : [];
    },
    isSelected(item) {
      return (
        this.selectedItems.findIndex((selectedItem) => {
          return selectedItem.id === item.id;
        }) !== -1
      );
    },
    handleViewList(view) {
      if (view === 'all') {
        this.displayFirmware = false;
      } else {
        this.displayFirmware = true;
      }
      if (this.displayImage) {
        this.showVideo = false;
        this.delayPromise(300).then(() => {
          this.showVideo = true;
        });
      }
    },
    handleSelectDisplayImage(index) {
      this.displayImage = !!index;
      this.$refs.page.onResize();
    },
    toggleSelect(item) {
      if (this.selectedItems.findIndex((value) => value.id === item.id) > -1) {
        this.selectedItems = this.selectedItems.filter(
          (value) => value.id !== item.id
        );
      } else {
        this.selectedItems.push(item);
      }
    },
  },
};
</script>

<style lang="scss">
.firmwareCamsTable {
  &_circle-icon {
    width: 9px;
    height: 9px;
    background-color: #fcc800;
    border-radius: 50%;
    position: absolute;
    top: -4px;
    right: 0;
  }
  &_display-image {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    .imageDisplaySelect {
      width: 100%;
      &_controller {
        justify-content: flex-end;
      }
      &_cams {
        justify-content: flex-end;
      }
    }
  }
  &_image {
    position: relative;
    &-rotate {
      position: absolute;
      margin-left: auto;
      margin-right: auto;
      top: 26px;
      left: 58px;
      text-align: center;
      z-index: 1;
    }
  }
  &_update {
    &-btn {
      &.v-btn:not(.v-btn--round).v-size--default {
        margin-top: 10px;
        width: 160px;
        height: 23px;
        border-radius: 5px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
        background-color: #0075c2;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
      }
    }
    &-message,
    &-warn {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      margin-bottom: 5px;
    }
    &-warn {
      color: #eb545b;
      margin-bottom: 17px;
    }
  }
  &_tabs {
    width: 337px;

    .v-slide-group__content.v-tabs-bar__content {
      border-radius: 5px;
      background-color: #eee;
      padding: 2px 0;
    }
    .v-tab {
      font-size: 13px;
      width: 166px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: normal;
      text-align: left;
    }
    &-active {
      border-radius: 5px;
      background-color: #fff;
      color: #0075c2;
    }
    &-wrapper {
      position: relative;
      margin: 15px 0;
      width: 342px;
      height: 25px;
    }
  }
  &_gap-header {
    height: 5px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &-tooltip {
      width: 300px !important;
      height: auto !important;
      word-break: break-word;
      padding-bottom: 10px !important;
    }
    &--header-name {
      max-width: 250px;
    }
    &-name {
      max-width: 85%;
      //max-width: 250px;
    }
    &.v-data-table
      > .v-data-table__wrapper
      > table
      > thead
      > tr:last-child
      > th {
      padding-bottom: 5px;
    }
    .videoStream {
      width: 117.3px;
      height: 66px;
      margin: 10px 0;
    }
    &-img {
      margin: 10px;
    }
    &-dateTime {
      font-size: 14px;
      font-weight: 600;
      color: #666;
      text-align: center;
    }
    &-packageVersion {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-modelName {
      font-size: 14px;
      font-weight: 600;
      color: #666;
    }
    &-serialNumber {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      font-family: 'Noto Sans JP', sans-serif;
    }
    &-firmwareVerion,
    &-firmwareUpdate {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
      display: block;
      font-family: 'Noto Sans JP', sans-serif;
    }
    &-firmwareUpdateMessage {
      font-size: 12px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &-firmwareUpdate {
      color: #0075c2;
      cursor: pointer;
    }
  }
  td {
    vertical-align: middle;
  }
  th {
    vertical-align: bottom;
    min-width: 130px;
    span {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }

  tr {
    cursor: pointer;
    &.selected {
      background-color: #f3f3f3 !important;
      border-color: #f3f3f3 !important;
    }
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_content {
    position: relative;
    &.theme--light.v-sheet {
      border-radius: 0;
      box-shadow: none;
      padding: 0;
    }
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
  &_dialog {
    position: relative;

    &-cancel {
      color: #989898 !important;
    }
    &-update {
      &.v-btn.v-btn--has-bg {
        background-color: #0075c2 !important;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
      }
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
      display: flex;
      flex-direction: column;
      gap: 10px;
      &--warn {
        font-weight: bold;
        color: #eb545b;
      }
    }
  }
  &_rotate {
    animation: rotation 4s infinite linear;
  }

  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
}
</style>
